import HttpService from "./http.service";

// Route to create a new order
export const createOrder = async(data) => {
    return await HttpService.post("/orders", data);
};

// Route to get all the orders
export const getOrders = async() => {
    return await HttpService.get("/orders");
};

// Route to get an order by its ID
export const getOrderById = async(orderId) => {
    return await HttpService.get(`/orders/${orderId}`);
};

// Route to get orders for a specific organization
export const getOrgOrders = async(orgId) => {
    return await HttpService.get(`/orders/org/${orgId}`);
};

// Route to get orders with their products
export const getOrdersWithProducts = async() => {
    return await HttpService.get(`/orders/products/`);
};

// Route to update an existing order
export const updateOrder = async(orderId, data) => {
    return await HttpService.put(`/orders/${orderId}`,data);
};

// Route to get recent orders, optionally filtered by organization
export const getRecentOrders = async (orgId)=>{
    return await HttpService.get(`/orders/recent/${orgId}`);
};

// Route to delete an order by its ID
export const deleteOrder = async (orderId, userId) => {
    return await HttpService.delete(`/orders/${orderId}/${userId}`);
};

export default {
    createOrder,
    getOrders,
    getOrderById,
    updateOrder,
    getOrgOrders,
    getOrdersWithProducts,
    getRecentOrders,
    deleteOrder
};